import { handleAxiosError } from '@/api/helpers';
import { useBeeFreeToken } from '@/hooks/query/bee-free.hook';
import { useAppSelector } from '@/hooks/store';
import { useToast } from '@/hooks/useToast';
import { LoadingPage } from '@/pages';
import { selectCurrentAccount } from '@/store/features/account';
import BeefreeSDK, { beeTypes } from '@beefree.io/sdk';
import { AxiosError } from 'axios';
import { t } from 'i18next';
import React, { useEffect, useRef, useState } from 'react';

type BeePluginEmailContainerProps = {
  template: any;
  handleChange: (page: beeTypes.IEntityContentJson) => void;
  handleSave: (page: object, html: string) => void;
  handleSendTest?: (html: string) => void;
};

export const BeePluginEmailContainer: React.FC<
  BeePluginEmailContainerProps
> = ({ template, handleChange, handleSave, handleSendTest }) => {
  const account = useAppSelector(selectCurrentAccount);
  const toast = useToast();
  const ref = useRef(null);
  const [beeToken, setBeeToken] = useState<beeTypes.IToken | undefined>();
  const [isLoading, setIsLoading] = useState(false);
  const { create: getBeeFreeToken } = useBeeFreeToken();

  // If the plugin was already initialized and the token is present, don't get it
  useEffect(() => {
    if (!account) {
      return;
    }

    const getToken = async () => {
      setIsLoading(true);
      const token = await getBeeFreeToken({
        uid: account?.id as string,
        type: 'email',
      });

      setBeeToken(token);
      setIsLoading(false);
    };
    getToken();
  }, [account?.id]);

  useEffect(() => {
    if (!beeToken) {
      return;
    }

    const loadEditor = async () => {
      try {
        if (!account || !beeToken) {
          return;
        }

        const beeEmailEditor = new BeefreeSDK(beeToken);
        beeEmailEditor.start(
          {
            container: 'beeplugin-editor',
            uid: account?.id as string,
            trackChanges: true,
            preventClose: true,
            onChange: (page) => {
              handleChange(JSON.parse(page));
            },
            onSend: (html) => {
              if (!handleSendTest) return;
              handleSendTest(html);
            },
            onSave: (page, html) => {
              // if (!handleSave) return;
              handleSave(JSON.parse(page), html);
            },
            commenting: true,
          },
          template,
        );
      } catch (e) {
        handleAxiosError(e as Error | AxiosError, toast);
      }
    };

    loadEditor();
  }, [beeToken, account?.id]);

  return (
    <div>
      {isLoading && <LoadingPage message={t('generic.loading')} />}
      {!isLoading && (
        <div id="beeplugin-editor" ref={ref} style={{ height: '100%' }}></div>
      )}
    </div>
  );
};
